import { NoMatch } from "./page/error/404";
import Unauthorised from "./page/error/unauthorised";
import Modal from "react-modal";
import { Login } from "./page/auth/login";
import { Checkout } from "./page/checkout";
import { Navigate, Route, Routes } from "react-router";
import { Logger } from "aws-amplify";
import { ConfigureQRRedirect } from "./page/configureQRRedirect";
import { WindcavePaymentCallback } from "./page/windcavePaymentCallback";
import { ToastContainer } from "../tabin/components/toast";
import { Logout } from "./page/auth/logout";
import { BrowserRouter } from "react-router-dom";
import { OrderPlaced } from "./page/orderPlaced";
import { Restaurant } from "./page/restaurant";
import { Reservation } from "./page/reservation";
import { ReservationConfirmed } from "./page/reservationConfirmed";
import { AuthenticationStatus, useAuth } from "../context/auth-context";
import { useUser } from "../context/user-context";
import { FullScreenSpinner } from "../tabin/components/fullScreenSpinner";
import { AlertProvider } from "../tabin/components/alert";
import "react-toastify/dist/ReactToastify.min.css";

let electron: any;
let ipcRenderer: any;
try {
    electron = window.require("electron");
    ipcRenderer = electron.ipcRenderer;
} catch (e) {}

const logger = new Logger("Main");

Modal.setAppElement("#root");

// Auth routes
export const loginPath = "/login";
export const restaurantListPath = "/";
export const restaurantPath = "/restaurant";
export const configureQRRedirectPath = "/configure_qr_redirect";
export const checkoutPath = "/checkout";
export const orderPlacedPath = "/order_placed";
export const windcavePaymentCallbackPath = "/windcave_payment_callback";
export const deliveryPath = "/delivery";
export const logoutPath = "/log_out";
export const unauthorizedPath = "/unauthorized";
export const reservationPath = "/reservation";
export const reservationConfirmedPath = "/reservation/confirmed";

export default () => {
    return (
        <>
            <AlertProvider>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
                <ToastContainer />
                <ToastContainer />
            </AlertProvider>
        </>
    );
};

const AppRoutes = () => {
    return (
        <Routes>
            <Route path={loginPath} element={<Login />} />
            <Route path={logoutPath} element={<Logout />} />
            <Route path={checkoutPath} element={<Checkout />} />
            <Route path={windcavePaymentCallbackPath} element={<WindcavePaymentCallback />} />
            <Route path={`${orderPlacedPath}`} element={<OrderPlaced />} />
            <Route path={`${restaurantPath}/:restaurantId`} element={<Restaurant />} /> {/* Old method */}
            <Route path={`:restaurantId${reservationConfirmedPath}`} element={<ReservationConfirmed />} />
            <Route path={`:restaurantId${reservationPath}`} element={<Reservation />} />
            <Route path={`:restaurantId`} element={<Restaurant />} />
            <Route path={configureQRRedirectPath} element={<PrivateRoute element={<ConfigureQRRedirect />} />} />
            <Route path={unauthorizedPath} element={<Unauthorised />} />
            <Route path="*" element={<NoMatch />} />
        </Routes>
    );
};

const PrivateRoute = ({ element }) => {
    const { status } = useAuth();
    const { user, isLoading } = useUser();

    if (status !== AuthenticationStatus.SignedIn) return <Navigate to={loginPath} />; // Handle other authentication statuses
    if (isLoading) return <FullScreenSpinner show={true} text="Loading user..." />; // Assumed signed in from this point onwards
    if (!user) throw "Signed in but no user found in database";

    return element; // Route to original path
};
